if (!customElements.get('product-card-video')) {
  customElements.define('product-card-video', class ProductCardVideo extends HTMLElement {
    constructor() {
      super();
      this.productCard = this.closest('.card--product');
      this.video = this.querySelector('.card__hover-video');

      this.productCard.addEventListener('mouseenter', this.playVideo.bind(this));
      this.productCard.addEventListener('mouseleave', this.pauseVideo.bind(this));
    }

    playVideo() {
      this.video.play();
    }

    pauseVideo() {
      this.video.pause();
      this.video.currentTime = 0;
    }
  });
}
